import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import messages from './notes.messages';

import { Container, Title, Description, NotesField } from './notes.styles';

export class Notes extends PureComponent {
  static propTypes = {
    notes: PropTypes.string,
    onNotesChanged: PropTypes.func.isRequired,
  };

  handleNotesChanged = e => {
    this.props.onNotesChanged(e.target.value);
  };

  render() {
    return (
      <Container>
        <Title>
          <FormattedMessage {...messages.title} />
        </Title>
        <Description>
          <FormattedMessage {...messages.description} />
        </Description>
        <NotesField value={this.props.notes} onChange={this.handleNotesChanged} />
      </Container>
    );
  }
}
